/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-max-props-per-line */
import PropTypes from 'prop-types';
import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Component } from 'react';
import { Card } from 'primereact/card';
import moment from 'moment';
import Constants from '../utils/constants';
import ActionLink from './ActionLink';
import { locale, addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import AuthService from '../services/AuthService';


export class YearCalendarGridComponent extends Component {
    constructor(props) {
        super(props);
        const items = [];
        this.state = {
            items,
            selectedDate: undefined,
        };

        this.renderMonthCalendar = this.renderMonthCalendar.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.dateTemplate = this.dateTemplate.bind(this);
        this.authService = new AuthService();
    }

    componentDidMount() {
        addLocale('pl', {
            firstDayOfWeek: 1,
            dayNamesMin: ['Ndz.', 'Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.'],
        });
        locale('pl');
    }

    componentDidUpdate() {

    }


    onDateChange(rowData) {
        //sprawdzam, czy wybrana data jest wśród świąt/dni wolnych
        //jeśli tak to nie ma się wyświetlać dialog z dodaniem nowego świeta, tylko okienko z nazwą święta i mozliwością jego usunięcia
        if(this.authService.isUserInRole('ROLE_PUBLIC_HOLIDAYS_EDIT')){
            if (!this.props.eventsDates?.includes(this.formatDate(rowData.value))) {
                this.props.openDialog(rowData);
            }
        }

    }

    formatDate(date) {
        let formattedDate = moment(date).format(Constants.DATE_GET_REQUEST_FORMAT);
        return formattedDate;

    }

    dateTemplate(date) {
        const op = React.createRef();
       
        let formattedDate = moment(new Date(date.year, date.month, date.day)).format(Constants.DATE_GET_REQUEST_FORMAT);
        let createElementId =  'id-' + formattedDate;
        let eventName = this.props.events?.filter(e => moment(e.date).format(Constants.DATE_GET_REQUEST_FORMAT) === formattedDate)[0]?.name;

        let customStyle = this.props.eventsDates?.includes(formattedDate);
        if (customStyle === true) {
            return (
                <div id={createElementId}>
                    <OverlayPanel id={`overlay-panel-${formattedDate}`} ref={op} className="lr-overlay">
                        <div className="flex align-items-center" >
                            <span style={{ minWidth: '5rem', marginRight: '10px' }}>{eventName}</span>
                            <ActionLink
                                id={'delete-ph-icon'}
                                iconName='mdi-delete'
                                iconSide='left'
                                iconSize='icon-large'
                                variant='red'
                                className='edit-blue-link'
                                key={`delete-button${formattedDate}`}
                                iconLabel="Usuń z kalendarza"
                                handleClick={() => this.props.yesNoDialog(date)}
                                rendered={this.authService.isUserInRole('ROLE_PUBLIC_HOLIDAYS_EDIT')}
                            />
                        </div>
                    </OverlayPanel>

                    <div className={`testOverlay${formattedDate}`} style={{ userSelect: 'none', backgroundColor: '#1dcbb3', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', padding: 0 }}
                        onClick={(e) => {
                            if (!!!this.props.embedded) {
                                op.current.toggle(e)
                            }

                        }}
                    >{date.day}</div>
                </div>

            );
        }
        else {
            return  <div id={createElementId}>{date.day}</div>;
        }
    }

    renderMonthCalendar = (month) => {
        const selectedYear = this.props.selectedYear;
        const date = new Date(selectedYear, month, 1);
        const min = date;
        const max = new Date(selectedYear, month + 1, 0);
        return (
            <div className="month-container" key={month}>
                <h3>{date.toLocaleString('default', { month: 'long' })}</h3>
                <Calendar
                    value={null}
                    onChange={this.onDateChange}
                    dateFormat="dd/mm/yy"
                    inline
                    showIcon
                    monthNavigator
                    yearNavigator
                    yearRange={`${selectedYear}:${selectedYear}`}
                    minDate={min} // Zapewnia, że kalendarz nie wyświetli dat z poprzednich lat
                    maxDate={max} // Ogranicza daty do bieżącego miesiąca
                    dateTemplate={this.dateTemplate.bind(this)}
                    viewDate={min}
                />
            </div>
        );
    };

    render() {
        const { items } = this.state;
        return (
            <React.Fragment>
                <Card //title="Kalendarz dni wolnych"
                >
                    <div className="calendar-grid">
                        {/* Siatka z mini kalendarzami */}
                        {Array.from({ length: 12 }, (_, i) => this.renderMonthCalendar(i))}
                    </div>
                </Card>
            </React.Fragment>
        );
    }
}

YearCalendarGridComponent.defaultProps = {
    className: '',
    visible: false,
    content: ''
};

YearCalendarGridComponent.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    visible: PropTypes.bool,
    content: PropTypes.string,
    selectedYear: PropTypes.number,
    eventsDates: PropTypes.array,
    events: PropTypes.array,
    openDialog: PropTypes.func,
    yesNoDialog: PropTypes.func,
    visible: PropTypes.bool

};
